import { useNavigate, useLocation } from "react-router-dom";
import { useState, useContext } from "react";
import { IoIosClose } from "react-icons/io";
import { IoCalendarOutline, IoFastFoodOutline, IoPersonOutline, IoLogOutOutline, IoMenu } from "react-icons/io5";
import logo from "../assets/images/gentium.png";
import { Link } from "react-router-dom";
import { BsPcDisplayHorizontal } from "react-icons/bs";
import AuthContext from "../context/AuthProvider";

function Sidebar() {
    const { role } = useContext(AuthContext);
    const navigate = useNavigate();
    const location = useLocation();
    const [isOpen, setIsOpen] = useState(false);

    const handleLinkClick = () => {
        setIsOpen(false);
    };

    const handleLogout = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("isDayStarted");
        navigate('/login');
    };

    const isActiveLink = (path) => {
        return location.pathname === path;
    };

    return (
        <>
            <button
                onClick={() => setIsOpen(!isOpen)}
                className="lg:hidden fixed top-4 left-4 z-50 p-2 rounded-md bg-white text-black"
                aria-expanded={isOpen}
            >
                {isOpen ? <IoIosClose color='red' className="w-6 h-6" /> : <IoMenu color='blue' className="w-6 h-6" />}
            </button>
            <nav className={`bg-white shadow-xl h-screen fixed top-0 left-0 min-w-[250px] py-6 px-4 font-[sans-serif] overflow-auto transition-transform duration-300 ease-in-out lg:translate-x-0 ${isOpen ? 'translate-x-0' : '-translate-x-full'}`} style={{ fontFamily: 'Poppins, sans-serif' }}>
                <div className="relative flex flex-col h-full">
                    <Link to="/dashboard" className="text-center">
                        <img src={logo} alt="logo" className='w-12 inline' />
                    </Link>

                    <ul className="space-y-3 my-8 flex-1">
                        {role && role.includes('admin') &&
                            <li>
                                <Link
                                    to="/dashboard"
                                    onClick={handleLinkClick}
                                    className={`text-sm flex items-center transition-all px-8 py-4 ${isActiveLink("/dashboard") ? "text-[#610c63] border-r-[5px] border-[#610c63] bg-gray-100" : "text-black hover:text-[#610c63] hover:border-r-[5px] border-[#610c63] hover:bg-gray-100"}`}>
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" className="w-[18px] h-[18px] mr-4" viewBox="0 0 512 512">
                                        <path d="M197.332 170.668h-160C16.746 170.668 0 153.922 0 133.332v-96C0 16.746 16.746 0 37.332 0h160c20.59 0 37.336 16.746 37.336 37.332v96c0 20.59-16.746 37.336-37.336 37.336zM37.332 32A5.336 5.336 0 0 0 32 37.332v96a5.337 5.337 0 0 0 5.332 5.336h160a5.338 5.338 0 0 0 5.336-5.336v-96A5.337 5.337 0 0 0 197.332 32zm160 480h-160C16.746 512 0 495.254 0 474.668v-224c0-20.59 16.746-37.336 37.332-37.336h160c20.59 0 37.336 16.746 37.336 37.336v224c0 20.586-16.746 37.332-37.336 37.332zm-160-266.668A5.337 5.337 0 0 0 32 250.668v224A5.336 5.336 0 0 0 37.332 480h160a5.337 5.337 0 0 0 5.336-5.332v-224a5.338 5.338 0 0 0-5.336-5.336zM474.668 512h-160c-20.59 0-37.336-16.746-37.336-37.332v-96c0-20.59 16.746-37.336 37.336-37.336h160c20.586 0 37.332 16.746 37.332 37.336v96C512 495.254 495.254 512 474.668 512zm-160-138.668a5.338 5.338 0 0 0-5.336 5.336v96a5.337 5.337 0 0 0 5.336 5.332h160a5.336 5.336 0 0 0 5.332-5.332v-96a5.337 5.337 0 0 0-5.332-5.336zm160-74.664h-160c-20.59 0-37.336-16.746-37.336-37.336v-224C277.332 16.746 294.078 0 314.668 0h160C495.254 0 512 16.746 512 37.332v224c0 20.59-16.746 37.336-37.332 37.336zM314.668 32a5.337 5.337 0 0 0-5.336 5.332v224a5.338 5.338 0 0 0 5.336 5.336h160a5.337 5.337 0 0 0 5.332-5.336v-224A5.336 5.336 0 0 0 474.668 32zm0 0" />
                                    </svg>
                                    <span>Dashboard</span>
                                </Link>
                            </li>}
                        {role && role.includes('admin') &&
                            <li>
                                <Link
                                    to="/reservations"
                                    onClick={handleLinkClick}
                                    className={`text-sm flex items-center transition-all px-8 py-4 ${isActiveLink("/reservations") ? "text-[#610c63] border-r-[5px] border-[#610c63] bg-gray-100" : "text-black hover:text-[#610c63] hover:border-r-[5px] border-[#610c63] hover:bg-gray-100"}`}>
                                    <IoCalendarOutline size={24} className="mr-4" />
                                    <span>Reservation</span>
                                </Link>
                            </li>}

                        <li>
                            <Link
                                to="/caisse"
                                onClick={handleLinkClick}
                                className={`text-sm flex items-center transition-all px-8 py-4 ${isActiveLink("/caisse") ? "text-[#610c63] border-r-[5px] border-[#610c63] bg-gray-100" : "text-black hover:text-[#610c63] hover:border-r-[5px] border-[#610c63] hover:bg-gray-100"}`}>
                                <BsPcDisplayHorizontal size={24} className="mr-4" />
                                <span>Caisse</span>
                            </Link>
                        </li>

                        {role && role.includes('admin') &&
                            <li>
                                <Link
                                    to="/menu"
                                    onClick={handleLinkClick}
                                    className={`text-sm flex items-center transition-all px-8 py-4 ${isActiveLink("/menu") ? "text-[#610c63] border-r-[5px] border-[#610c63] bg-gray-100" : "text-black hover:text-[#610c63] hover:border-r-[5px] border-[#610c63] hover:bg-gray-100"}`}>
                                    <IoFastFoodOutline size={24} className="mr-4" />
                                    <span>Menu</span>
                                </Link>
                            </li>}
                    </ul>

                    <div className="mt-auto space-y-3">
                        {role && role.includes('admin') &&
                            <Link
                                to="/profile"
                                onClick={handleLinkClick}
                                className={`text-sm flex items-center transition-all px-8 py-4 ${isActiveLink("/profile") ? "text-[#610c63] border-r-[5px] border-[#610c63] bg-gray-100" : "text-black hover:text-[#610c63] hover:border-r-[5px] border-[#610c63] hover:bg-gray-100"}`}>
                                <IoPersonOutline size={24} className="mr-4" />
                                <span>Profile</span>
                            </Link>}
                        <button
                            onClick={handleLogout}
                            className="w-full text-sm flex items-center transition-all px-8 py-4 text-black hover:text-[#610c63] hover:border-r-[5px] border-[#610c63] hover:bg-gray-100">
                            <IoLogOutOutline size={24} className="mr-4" />
                            <span>Logout</span>
                        </button>
                    </div>
                </div>
            </nav>
        </>
    );
}

export default Sidebar;